import {
  Box,
  Flex,
  HStack,
  Separator,
  Stack,
  StackSeparator,
  Text,
  VStack,
} from "@chakra-ui/react";
import { SelectedNodeImage } from "../shared/SelectedNodeImage";
import { observer } from "mobx-react-lite";
import { NodeNavControls } from "../../../../../shared/views/NodeNavControls/NodeNavControls";
import { MainMap } from "../../MainMap";
import { SelectFirstNodeThumbnail } from "../../DetailBar/osaway/SelectFirstNodeThumbnail";
import { t } from "i18next";
import { ConflictWarning } from "../ConflictWarning";
import { useStores } from "../../../../../shared/stores/RootStore";
import { MapControls } from "../../MapControls";
import { MapComponentVisibilityControls } from "../../MapComponentVisibilityControls";
import { ShortcutList } from "../../overlay/ShortcutList";
import { ViewComments } from "../../BottomBar/ViewComments";
import { CodingConsole } from "./CodingConsole";
import { MapComponent, MapMode } from "../../../../../project/stores/MapStore";
import { MapLegend } from "../../overlay/MapLegend";
import { MultiSelectionWarning } from "../MultiSelectionWarning";

const NodeViewBase = () => {
  const { osaWayStore, mapStore, osaNodeStore } = useStores();
  const selectedNode = osaNodeStore.getSelected();

  const way = osaWayStore.getSelected()!;
  const nodes = osaNodeStore.nodesByWayId.get(way.id);
  const firstNode = nodes?.[0];

  const mode = mapStore.mode === MapMode.ManageNodes

  return (
    <HStack
      alignItems="stretch"
      separator={<StackSeparator />}
      gap={0}
      flexGrow={1}
      justifyContent="center"
      overflow="auto"
    >
      <Stack
        width="40%"
        overflow="auto"
        flexShrink={0}
        gap={0}
        separator={<StackSeparator />}
      >
        <Flex flexBasis={1} position="relative" flexGrow={1} flexShrink={0}>
          <MainMap reducedMapSize />
          <MapControls hideQueryPolygon />
          <MapLegend />

          <Stack
            bottom={16}
            left={4}
            position="absolute"
            zIndex={1}
            pointerEvents={"none"}
            alignItems={"start"}
            gap={4}
          >
            {mapStore.componentVisibility.shortcuts &&  <ShortcutList  showMultiSelection={mode}/>}
            <MapComponentVisibilityControls
              components={[MapComponent.Shortcuts]}
            />
          </Stack>
        </Flex>

        {!!selectedNode && (
          <Flex
            flexBasis={1}
            position="relative"
            flexGrow={1}
            h="50%"
            flexShrink={1}
          >
            <SelectedNodeImage />
            <Box
              position="absolute"
              bottom="15px"
              left="50%"
              transform="translateX(-50%)"
            >
              <NodeNavControls />
            </Box>
          </Flex>
        )}
      </Stack>
      <VStack flexGrow={1} alignItems="stretch" position="relative" gap={0}>
        <ConflictWarning />
        <MultiSelectionWarning />

        {!!selectedNode ? (
          <CodingConsole />
        ) : (
          <VStack flexGrow={1} justifyContent="center" justifySelf={"center"}>
            <Text>{t("coding:selectNodeToCode")}</Text>
            <Box maxW={"300px"}>
              {!!firstNode?.photo && (
                <SelectFirstNodeThumbnail
                  firstNode={firstNode}
                  selectNodeById={(nodeId) => {
                    osaNodeStore.select(nodeId);
                    mapStore.recenterMap();
                  }}
                />
              )}
            </Box>
          </VStack>
        )}

        <Separator />
        <ViewComments />
      </VStack>
    </HStack>
  );
};

export const NodeView = observer(NodeViewBase);
